import React, { Component } from "react"

class JoinOtaaAbp extends Component {

    handleChange = (field, value) => {
        const detalhes = Object.assign({}, this.props.detalhes)
        const errors = Object.assign({}, this.props.errors)

        detalhes[field] = value
    
        if(field in errors) {
            delete errors[field]
            this.props.setErrors(errors)
        }
        
        this.props.setDetalhes(detalhes)
    }
    
    render() {
        const { detalhes, errors, isTemplate } = this.props

        return(
            <div className="hdv-form-default">

                <div className="row">
                    <div className="col-md-12">
                        <label className="required" htmlFor="supports_otaa" title="O dispositivo suporta OTAA">O dispositivo suporta OTAA</label>
                        <input
                            type='checkbox'
                            checked={detalhes.supports_otaa}
                            id="supports_otaa"
                            onChange={(e) => this.handleChange("supports_otaa", e.target.checked)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-supports_otaa'>{ errors["supports_otaa"] ?? ""  }</span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <label className="required" htmlFor="abp_rx1_delay" title="Atraso RX1">Atraso RX1</label>
                        <input
                            type='text'
                            value={detalhes.abp_rx1_delay ?? ""}
                            id="abp_rx1_delay"
                            disabled={detalhes.supports_otaa || isTemplate}
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("abp_rx1_delay", value)
                            }}
                        />
                        <span id='validacao-abp_rx1_delay'>{ errors["abp_rx1_delay"] ?? ""  }</span>
                    </div>
                    <div className="col-md-6">
                        <label className="required" htmlFor="abp_rx1_dr_offset" title="Deslocamento da taxa de dados RX1">Deslocamento da taxa de dados RX1</label>
                        <input
                            type='text'
                            value={detalhes.abp_rx1_dr_offset ?? ""}
                            id="abp_rx1_dr_offset"
                            disabled={detalhes.supports_otaa || isTemplate}
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("abp_rx1_dr_offset", value)
                            }}
                        />
                        <span id='validacao-abp_rx1_dr_offset'>{ errors["abp_rx1_dr_offset"] ?? ""  }</span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <label className="required" htmlFor="abp_rx2_dr" title="Taxa de dados RX2">Taxa de dados RX2</label>
                        <input
                            type='text'
                            value={detalhes.abp_rx2_dr ?? ""}
                            id="abp_rx2_dr"
                            disabled={detalhes.supports_otaa || isTemplate}
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("abp_rx2_dr", value)
                            }}
                        />
                        <span id='validacao-abp_rx2_dr'>{ errors["abp_rx2_dr"] ?? ""  }</span>
                    </div>
                    <div className="col-md-6">
                        <label className="required" htmlFor="abp_rx2_freq" title="Frequência RX2 (Hz)">Frequência RX2 (Hz)</label>
                        <input
                            type='text'
                            value={detalhes.abp_rx2_freq ?? ""}
                            id="abp_rx2_freq"
                            disabled={detalhes.supports_otaa || isTemplate}
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("abp_rx2_freq", value)
                            }}
                        />
                        <span id='validacao-abp_rx2_freq'>{ errors["abp_rx2_freq"] ?? ""  }</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default JoinOtaaAbp